const NULL_ADDR = '0x0000000000000000000000000000000000000000';
export const USDT_DECIMALS = 6n;
export const ONE_B = 1_000_000_000n;
export const ONE_M = 1_000_000n;
export const HUNDRED_K = 100_000n;
export const ONE_K = 1_000n;
export const HUNDRED = 100n;

// Mirrors OrderDescEnum in sc-monad contracts/Enums.sol — keep in sync.
export const ORDER_DESC_ENUM = {
  OpenLong: 0,
  OpenShort: 1,
  CloseLong: 2,
  CloseShort: 3,
  Cancel: 4,
  IncreasePositionCollateral: 5,
  // In-place change of price / lot / expiry on a resting Open* order (single tx,
  // keeps orderId). Close* orders revert with CantChangeCloseOrder.
  Change: 6,
};

export const FREEZE_STATUS_ENUM = {
  None: 0,
  Investigation: 1,
  OFAC: 2,
  Other: 3,
};

// RMR - Risk Manager Result:
export const RMR = {
  Success: 0,
  AcctBalLtCollatReq: 1,
  PincLossGtAvailCollat: 2,
  PincAvailCollatLtCollatReq: 3,
  PinvLostGtAvailCollat: 4,
  PinvAvailCollatLtCollatReq: 5,
};

export const NO_EXPIRY_BLOCK = 0n;
export const UNDEF_LEVERAGE = 0;
export const UNDEF_PRICE = 0n;
export const UNDEF_LOT = 0;
